/*
 * Copyright (c) 2021. by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. ("Confidential Information"). You
 * shall not disclose such Confidential Information and shall use
 * it only in accordance with the terms of the license agreement
 * you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 24/03/2025
 */

import React from "react";
import { StyledEngineProvider, ThemeProvider } from "@mui/material";
import "./App.css";
import PageRoutes from "./pageRoutes";
import theme from "./theme/theme";
import { Provider } from "react-redux";
import { store } from "./store";
import ScrollToTop from "./services/scrollToTop";

function App() {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <StyledEngineProvider injectFirst>
          <ScrollToTop />
          <PageRoutes />
        </StyledEngineProvider>
      </ThemeProvider>
    </Provider>
  );
}


export default App;
